import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";         // ของเดิมคุณ
import LoadingScreen from "../components/LoadingScreen";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen label="กำลังตรวจสอบสิทธิ์…" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  return children;
}
